<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Revenue Stream by Zone Report</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Revenue Stream Report by Zone" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarStreams/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Revenue Stream by Zone Report</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item active">Revenue by Zone</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Revenue</p>
                      <h4 class="mb-0">{{formatPrice(grandTotal)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Zones</p>
                      <h4 class="mb-0">{{zones.length}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-target-lock font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Active Zones</p>
                      <h4 class="mb-0">{{activeZones}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Average per Zone</p>
                      <h4 class="mb-0">{{formatPrice(zones.length > 0 ? grandTotal / zones.length : 0)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-calculator font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Report Card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h4 class="card-title mb-0">
                        <i class="bx bx-table me-2"></i>Revenue by Stream and Zone
                      </h4>
                      <p class="text-muted mb-0 mt-1">{{displayDateRange}}</p>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <button @click="refreshData" class="btn btn-sm btn-outline-primary me-2" :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i> Refresh
                      </button>
                      <div class="btn-group me-2" role="group">
                        <button @click="setDateRange('today')" class="btn btn-sm" :class="dateRangeType === 'today' ? 'btn-primary' : 'btn-outline-primary'">Today</button>
                        <button @click="setDateRange('week')" class="btn btn-sm" :class="dateRangeType === 'week' ? 'btn-primary' : 'btn-outline-primary'">Week</button>
                        <button @click="setDateRange('month')" class="btn btn-sm" :class="dateRangeType === 'month' ? 'btn-primary' : 'btn-outline-primary'">Month</button>
                        <button @click="setDateRange('year')" class="btn btn-sm" :class="dateRangeType === 'year' ? 'btn-primary' : 'btn-outline-primary'">Year</button>
                        <button @click="setDateRange('custom')" class="btn btn-sm" :class="dateRangeType === 'custom' ? 'btn-primary' : 'btn-outline-primary'">Custom</button>
                      </div>
                      <button @click="toggleView" class="btn btn-sm btn-outline-secondary">
                        <i :class="viewType === 'amount' ? 'bx bx-dollar' : 'bx bx-percentage'"></i>
                        {{viewType === 'amount' ? 'Amount' : 'Percentage'}}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Filters and Date Range -->
                  <div class="row mb-4">
                    <div class="col-md-2" v-show="dateRangeType === 'custom'">
                      <label class="form-label">Date From</label>
                      <input v-model="dateFrom" class="form-control" type="date" :max="dateTo">
                    </div>
                    <div class="col-md-2" v-show="dateRangeType === 'custom'">
                      <label class="form-label">Date To</label>
                      <input v-model="dateTo" class="form-control" type="date" :min="dateFrom" :max="maxDate">
                    </div>
                    <div class="col-md-2" v-show="dateRangeType === 'custom'">
                      <label class="form-label">&nbsp;</label>
                      <button @click="getRevenueData" class="btn btn-primary w-100">
                        <i class="bx bx-search me-1"></i>Apply
                      </button>
                    </div>

                    <!-- Sub-County Filter -->
                    <div class="col-md-2" :class="dateRangeType === 'custom' ? '' : ''">
                      <label class="form-label">Sub-County</label>
                      <select v-model="selectedSubCounty" @change="onSubCountyChange" class="form-select">
                        <option value="">All Sub-Counties</option>
                        <option v-for="sc in subCounties" :key="sc.subCountyName" :value="sc.subCountyName">
                          {{sc.subCountyName}}
                        </option>
                      </select>
                    </div>

                    <!-- Ward Filter -->
                    <div class="col-md-2">
                      <label class="form-label">Ward</label>
                      <select v-model="selectedWard" @change="getRevenueData" class="form-select" :disabled="!filteredWards.length">
                        <option value="">All Wards</option>
                        <option v-for="ward in filteredWards" :key="ward.wardName" :value="ward.wardName">
                          {{ward.wardName}}
                        </option>
                      </select>
                    </div>

                    <!-- Download Buttons -->
                    <div class="col-md-2 text-end" :class="dateRangeType === 'custom' ? '' : ''">
                      <label class="form-label">&nbsp;</label>
                      <div>
                       <button v-if="getRight('DOWNLOAD BY STREAMS REPORTS')" @click="downloadToExcel" class="btn btn-success btn-sm me-1" :disabled="revenueStreams.length === 0">
                          <i class="mdi mdi-file-excel"></i> Excel
                        </button>
                        <button v-if="getRight('DOWNLOAD BY STREAMS REPORTS')" @click="downloadToCSV" class="btn btn-info btn-sm" :disabled="revenueStreams.length === 0">
                          <i class="mdi mdi-file-delimited"></i> CSV
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filter Alert -->
                  <div v-if="selectedSubCounty || selectedWard" class="alert alert-info alert-dismissible fade show" role="alert">
                    <i class="bx bx-info-circle me-2"></i>
                    Showing revenue data for
                    <span v-if="selectedWard">
                        <strong>{{selectedWard}}</strong> ward
                        <span v-if="selectedSubCounty"> in <strong>{{selectedSubCounty}}</strong> sub-county</span>
                      </span>
                    <span v-else-if="selectedSubCounty">
                        <strong>{{selectedSubCounty}}</strong> sub-county
                      </span>
                    <button type="button" class="btn-close" @click="clearFilters"></button>
                  </div>

                  <!-- Revenue Stream Table -->
                  <div class="table-responsive" style="max-height: 600px; overflow-y: auto;">
                    <table class="table table-bordered table-hover table-sm mb-0" v-if="!loading && revenueStreams.length > 0">
                      <thead class="table-dark sticky-top">
                      <tr>
                        <th class="text-center align-middle" style="min-width: 40px;" rowspan="3">#</th>
                        <th class="align-middle" style="min-width: 200px;" rowspan="3">REVENUE STREAM</th>
                        <th v-for="group in groupedZones" :key="group.subCounty"
                            :colspan="getTotalZoneCount(group)"
                            class="text-center align-middle bg-primary text-white">
                          {{group.subCounty}}
                        </th>
                        <th class="text-center align-middle bg-dark" style="min-width: 140px;" rowspan="3">TOTAL</th>
                      </tr>
                      <tr>
                        <template v-for="group in groupedZones">
                          <th v-for="wardGroup in group.wardGroups" :key="`${group.subCounty}-${wardGroup.ward}`"
                              :colspan="wardGroup.zones.length"
                              class="text-center align-middle bg-secondary text-white" style="font-size: 0.8rem;">
                            {{wardGroup.ward}}
                          </th>
                        </template>
                      </tr>
                      <tr>
                        <template v-for="group in groupedZones">
                          <template v-for="wardGroup in group.wardGroups">
                            <th v-for="zone in wardGroup.zones" :key="zone.zoneName"
                                class="text-center align-middle text-uppercase"
                                style="min-width: 80px; font-size: 0.7rem;">
                              {{zone.zoneName}}
                            </th>
                          </template>
                        </template>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(stream, index) in revenueStreams" :key="stream.incomeTypePrefix"
                          @click="openStreamTransactionsModal(stream)"
                          class="clickable-row"
                          style="cursor: pointer;"
                          @mouseover="$event.currentTarget.style.backgroundColor = '#f8f9fa'"
                          @mouseout="$event.currentTarget.style.backgroundColor = ''">
                        <td class="text-center">{{index + 1}}</td>
                        <td class="fw-semibold text-uppercase">
                          <span class="badge bg-secondary me-2">{{stream.incomeTypePrefix}}</span>
                          {{stream.revenueStream}}
                          <i class="bx bx-info-circle text-primary ms-2" title="Click to view transactions"></i>
                        </td>
                        <template v-for="group in groupedZones">
                          <template v-for="wardGroup in group.wardGroups">
                            <td v-for="zone in wardGroup.zones" :key="zone.zoneName" class="text-end">
                                  <span v-if="viewType === 'amount'" :class="getAmount(stream.revenueStream, zone.zoneName) > 0 ? 'text-success' : ''">
                                    {{formatPrice(getAmount(stream.revenueStream, zone.zoneName))}}
                                  </span>
                              <span v-else class="text-muted">
                                    {{getPercentage(stream.revenueStream, zone.zoneName)}}%
                                  </span>
                            </td>
                          </template>
                        </template>
                        <td class="text-end fw-bold bg-light">
                          {{formatPrice(streamTotals[stream.revenueStream] || 0)}}
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <td colspan="2" class="text-end fw-bold">ZONE TOTALS</td>
                        <template v-for="group in groupedZones">
                          <template v-for="wardGroup in group.wardGroups">
                            <td v-for="zone in wardGroup.zones" :key="zone.zoneName" class="text-end fw-bold">
                              {{formatPrice(zoneTotals[zone.zoneName] || 0)}}
                            </td>
                          </template>
                        </template>
                        <td class="text-end fw-bold bg-success text-white">
                          {{formatPrice(grandTotal)}}
                        </td>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0">Loading revenue data by zones...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && revenueStreams.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Revenue Data Available</h5>
                      <p class="text-muted">No revenue streams found for the selected criteria.</p>
                    </div>
                  </div>

                  <!-- Zone Summary -->
                  <div class="row mt-4" v-if="!loading && zones.length > 0">
                    <div class="col-12">
                      <div class="card bg-light">
                        <div class="card-body">
                          <h6 class="mb-3">Zone Performance Summary</h6>
                          <div class="row">
                            <div class="col-md-3">
                              <small class="text-muted">Highest Revenue Zone:</small>
                              <h6 class="mb-0">{{topZone.name}} ({{formatPrice(topZone.amount)}})</h6>
                            </div>
                            <div class="col-md-3">
                              <small class="text-muted">Active Zones:</small>
                              <h6 class="mb-0">{{activeZones}} of {{zones.length}}</h6>
                            </div>
                            <div class="col-md-3">
                              <small class="text-muted">Inactive Zones:</small>
                              <h6 class="mb-0">{{zones.length - activeZones}}</h6>
                            </div>
                            <div class="col-md-3">
                              <small class="text-muted">Zone Coverage:</small>
                              <h6 class="mb-0">{{zones.length > 0 ? ((activeZones / zones.length) * 100).toFixed(1) : 0}}%</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Revenue Stream Transactions Modal -->
      <div class="modal fade" id="revenueStreamModal" tabindex="-1" aria-labelledby="revenueStreamModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header bg-gradient-primary text-white">
              <div>
                <h4 class="modal-title mb-1" id="revenueStreamModalLabel">
                  <i class="bx bx-receipt me-2"></i>
                  {{selectedStream.streamName}}
                  <span class="badge bg-light text-primary ms-2">{{selectedStream.incomeTypePrefix}}</span>
                </h4>
                <p class="mb-0 opacity-75">
                  <i class="bx bx-calendar me-1"></i>{{displayDateRange}}
                  <span v-if="selectedSubCounty" class="ms-3">
                    <i class="bx bx-map me-1"></i>{{selectedSubCounty}} Sub-County
                  </span>
                  <span v-if="selectedWard" class="ms-3">
                    <i class="bx bx-buildings me-1"></i>{{selectedWard}} Ward
                  </span>
                </p>
              </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body p-0">
              <!-- Summary Cards Section -->
              <div class="bg-light p-4 border-bottom">
                <div class="row g-3" v-if="streamTransactions.summary">
                  <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body text-center p-3">
                        <div class="avatar-sm mx-auto mb-2">
                          <span class="avatar-title rounded-circle bg-primary">
                            <i class="bx bx-list-ul font-size-18"></i>
                          </span>
                        </div>
                        <h5 class="mb-1">{{streamTransactions.summary.totalTransactions}}</h5>
                        <p class="text-muted mb-0 small">Transactions</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body text-center p-3">
                        <div class="avatar-sm mx-auto mb-2">
                          <span class="avatar-title rounded-circle bg-success">
                            <i class="bx bx-money font-size-18"></i>
                          </span>
                        </div>
                        <h5 class="mb-1">{{formatPrice(streamTransactions.summary.totalAmount)}}</h5>
                        <p class="text-muted mb-0 small">Total Amount</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body text-center p-3">
                        <div class="avatar-sm mx-auto mb-2">
                          <span class="avatar-title rounded-circle bg-info">
                            <i class="bx bx-user font-size-18"></i>
                          </span>
                        </div>
                        <h5 class="mb-1">{{streamTransactions.summary.totalAgents}}</h5>
                        <p class="text-muted mb-0 small">Agents</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body text-center p-3">
                        <div class="avatar-sm mx-auto mb-2">
                          <span class="avatar-title rounded-circle bg-warning">
                            <i class="bx bx-map font-size-18"></i>
                          </span>
                        </div>
                        <h5 class="mb-1">{{streamTransactions.summary.totalSubCounties}}</h5>
                        <p class="text-muted mb-0 small">Sub-Counties</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body text-center p-3">
                        <div class="avatar-sm mx-auto mb-2">
                          <span class="avatar-title rounded-circle bg-secondary">
                            <i class="bx bx-buildings font-size-18"></i>
                          </span>
                        </div>
                        <h5 class="mb-1">{{streamTransactions.summary.totalWards}}</h5>
                        <p class="text-muted mb-0 small">Wards</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body text-center p-3">
                        <div class="avatar-sm mx-auto mb-2">
                          <span class="avatar-title rounded-circle bg-dark">
                            <i class="bx bx-current-location font-size-18"></i>
                          </span>
                        </div>
                        <h5 class="mb-1">{{streamTransactions.summary.totalZones}}</h5>
                        <p class="text-muted mb-0 small">Zones</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Main Content Area -->
              <div class="p-4">
                <!-- Filters and Actions -->
                <div class="row align-items-end mb-4">
                  <div class="col-lg-2 col-md-6 mb-3">
                    <label class="form-label fw-semibold">Sub-County</label>
                    <select v-model="streamFilters.subCounty" @change="filterStreamTransactions" class="form-select">
                      <option value="">All Sub-Counties</option>
                      <option v-for="sc in uniqueSubCounties" :key="sc" :value="sc">{{sc}}</option>
                    </select>
                  </div>
                  <div class="col-lg-2 col-md-6 mb-3">
                    <label class="form-label fw-semibold">Ward</label>
                    <select v-model="streamFilters.ward" @change="filterStreamTransactions" class="form-select">
                      <option value="">All Wards</option>
                      <option v-for="ward in uniqueWards" :key="ward" :value="ward">{{ward}}</option>
                    </select>
                  </div>
                  <div class="col-lg-2 col-md-6 mb-3">
                    <label class="form-label fw-semibold">Zone</label>
                    <select v-model="streamFilters.zone" @change="filterStreamTransactions" class="form-select">
                      <option value="">All Zones</option>
                      <option v-for="zone in uniqueZones" :key="zone" :value="zone">{{zone}}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 mb-3 text-lg-end">
                    <button @click="clearStreamFilters" class="btn btn-outline-secondary me-2">
                      <i class="bx bx-x me-1"></i>Clear Filters
                    </button>
                    <button @click="exportStreamTransactions" class="btn btn-success me-2">
                      <i class="mdi mdi-download me-1"></i>Export CSV
                    </button>
                    <button @click="toggleBreakdownView" class="btn btn-outline-info">
                      <i class="bx bx-chart-bar me-1"></i>
                      {{showBreakdown ? 'Hide' : 'Show'}} Breakdown
                    </button>
                  </div>
                </div>

                <!-- Smart Breakdown Section -->
                <div class="row mb-4" v-if="showBreakdown && streamTransactions.breakdown && streamTransactions.breakdown.length > 0">
                  <div class="col-12">
                    <div class="card border-0 shadow-sm">
                      <div class="card-header bg-white border-bottom">
                        <h6 class="mb-0">
                          <i class="bx bx-chart-bar me-2 text-primary"></i>
                          Revenue Breakdown by {{getBreakdownTitle()}}
                        </h6>
                      </div>
                      <div class="card-body p-0">
                        <div class="table-responsive">
                          <table class="table table-sm mb-0">
                            <thead class="table-light">
                            <tr>
                              <th class="border-0">{{getBreakdownTitle()}}</th>
                              <th class="border-0 text-center">Transactions</th>
                              <th class="border-0 text-end">Amount</th>
                              <th class="border-0 text-center">Share</th>
                              <th class="border-0">Distribution</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in streamTransactions.breakdown" :key="getBreakdownKey(item)">
                              <td class="fw-semibold">{{getBreakdownName(item)}}</td>
                              <td class="text-center">
                                <span class="badge bg-primary">{{item.transactionCount}}</span>
                              </td>
                              <td class="text-end fw-semibold">{{formatPrice(item.totalAmount)}}</td>
                              <td class="text-center">
                                  <span class="badge bg-success">
                                    {{streamTransactions.summary.totalAmount > 0 ? ((item.totalAmount / streamTransactions.summary.totalAmount) * 100).toFixed(1) : 0}}%
                                  </span>
                              </td>
                              <td>
                                <div class="progress" style="height: 8px;">
                                  <div class="progress-bar bg-primary" role="progressbar"
                                       :style="'width: ' + (streamTransactions.summary.totalAmount > 0 ? ((item.totalAmount / streamTransactions.summary.totalAmount) * 100).toFixed(1) : 0) + '%'">
                                  </div>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Transaction Details -->
                <div class="card border-0 shadow-sm">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">
                        <i class="bx bx-receipt me-2 text-primary"></i>Transaction Details
                        <span class="badge bg-light text-dark ms-2" v-if="filteredStreamTransactions.length > 0">
                          {{filteredStreamTransactions.length}} transactions
                        </span>
                      </h6>
                      <div v-if="streamTransactions.transactions && filteredStreamTransactions.length > streamTransactionPageSize">
                        <nav>
                          <ul class="pagination pagination-sm mb-0">
                            <li class="page-item" :class="{ disabled: streamTransactionCurrentPage === 1 }">
                              <a class="page-link" @click="streamTransactionCurrentPage = Math.max(1, streamTransactionCurrentPage - 1)">
                                <i class="bx bx-chevron-left"></i>
                              </a>
                            </li>
                            <li v-for="page in streamTransactionPageNumbers" :key="page" class="page-item" :class="{ active: page === streamTransactionCurrentPage }">
                              <a class="page-link" @click="streamTransactionCurrentPage = page">{{page}}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: streamTransactionCurrentPage === streamTransactionTotalPages }">
                              <a class="page-link" @click="streamTransactionCurrentPage = Math.min(streamTransactionTotalPages, streamTransactionCurrentPage + 1)">
                                <i class="bx bx-chevron-right"></i>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>

                  <div class="card-body p-0">
                    <!-- Transaction Cards for better mobile view -->
                    <div class="d-lg-none">
                      <div v-for="transaction in paginatedStreamTransactions" :key="transaction.transaction_code"
                           class="border-bottom p-3">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <span class="badge bg-secondary">{{transaction.transaction_code}}</span>
                          <span class="fw-bold text-success">{{formatPrice(transaction.amount)}}</span>
                        </div>
                        <h6 class="mb-1">{{transaction.names || 'N/A'}}</h6>
                        <p class="text-muted small mb-2">
                          <i class="bx bx-phone me-1"></i>{{transaction.phoneNumber || 'N/A'}} |
                          <i class="bx bx-user me-1"></i>{{transaction.idNo || 'N/A'}}
                        </p>
                        <p class="text-muted small mb-2">
                          <i class="bx bx-map me-1"></i>{{transaction.subCountyName}} - {{transaction.wardName}} - {{transaction.zone}}
                        </p>
                        <p class="text-muted small mb-2">{{transaction.feeDescription || transaction.description}}</p>
                        <small class="text-muted">
                          <i class="bx bx-time me-1"></i>{{formatDate(transaction.date)}}
                        </small>
                      </div>
                    </div>

                    <!-- Full Table for Desktop -->
                    <div class="table-responsive d-none d-lg-block" style="max-height: 60vh; overflow-y: auto;">
                      <table class="table table-hover mb-0" v-if="!streamTransactionLoading && streamTransactions.transactions && streamTransactions.transactions.length > 0">
                        <thead class="table-light sticky-top">
                        <tr>
                          <th class="border-0">Transaction</th>
                          <th class="border-0">Customer</th>
                          <th class="border-0 text-end">Amount</th>
                          <th class="border-0">Location</th>
                          <th class="border-0">Department</th>
                          <th class="border-0">Service</th>
                          <th class="border-0">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="transaction in paginatedStreamTransactions" :key="transaction.transaction_code">
                          <td>
                            <div>
                              <span class="badge bg-secondary mb-1">{{transaction.transaction_code}}</span>
                              <br>
                              <small class="text-muted">Bill: {{transaction.receiptNumber || 'N/A'}}</small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <div class="fw-semibold">{{transaction.names || 'N/A'}}</div>
                              <small class="text-muted">
                                <i class="bx bx-phone me-1"></i>{{transaction.phoneNumber || 'N/A'}}
                              </small>
                              <br>
                              <small class="text-muted">
                                <i class="bx bx-user me-1"></i>{{transaction.idNo || 'N/A'}}
                              </small>
                            </div>
                          </td>
                          <td class="text-end">
                            <span class="fw-bold text-success">{{formatPrice(transaction.amount)}}</span>
                          </td>
                          <td>
                            <div>
                              <div class="fw-semibold">{{transaction.subCountyName || 'N/A'}}</div>
                              <small class="text-muted">{{transaction.wardName || 'N/A'}}</small>
                              <br>
                              <small class="text-muted">Zone: {{transaction.zone || 'N/A'}}</small>
                            </div>
                          </td>
                          <td>
                            <small>{{transaction.department || 'N/A'}}</small>
                          </td>
                          <td>
                            <div>
                              <small class="fw-semibold">{{transaction.feeDescription || 'N/A'}}</small>
                              <br>
                              <small class="text-muted">{{transaction.incomeTypeDescription || 'N/A'}}</small>
                            </div>
                          </td>
                          <td>
                            <small>{{formatDate(transaction.date)}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Loading State -->
                    <div v-if="streamTransactionLoading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0 text-muted">Loading transactions...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!streamTransactionLoading && (!streamTransactions.transactions || streamTransactions.transactions.length === 0)" class="text-center py-5">
                      <div class="avatar-lg mx-auto mb-3">
                        <span class="avatar-title rounded-circle bg-light text-muted">
                          <i class="bx bx-info-circle font-size-24"></i>
                        </span>
                      </div>
                      <h5>No Transactions Found</h5>
                      <p class="text-muted">No transactions found for this revenue stream in the selected date range and filters.</p>
                    </div>
                  </div>

                  <!-- Pagination Footer -->
                  <div class="card-footer bg-light border-top" v-if="streamTransactions.transactions && filteredStreamTransactions.length > streamTransactionPageSize">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <small class="text-muted">
                          Showing {{((streamTransactionCurrentPage - 1) * streamTransactionPageSize) + 1}} to
                          {{Math.min(streamTransactionCurrentPage * streamTransactionPageSize, filteredStreamTransactions.length)}}
                          of {{filteredStreamTransactions.length}} transactions
                        </small>
                      </div>
                      <div>
                        <small class="text-muted me-3">
                          Page {{streamTransactionCurrentPage}} of {{streamTransactionTotalPages}}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="bx bx-x me-1"></i>Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Zone-Level Revenue Analysis
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>


<script>
/* eslint-disable */
import * as XLSX from 'xlsx';
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight} from "@/api";
import moment from 'moment';
import ToolBarStreams from "@/components/reports/streams/ToolBar.vue";

export default {
  name: "RevenueStreamZoneReport",
  components: {ToolBarStreams, NavigationBar},

  data() {
    return {
      loading: false,
      dateFrom: '',
      dateTo: '',
      maxDate: moment().format('YYYY-MM-DD'),
      dateRangeType: 'month',
      viewType: 'amount',
      selectedSubCounty: '',
      selectedWard: '',
      revenueStreams: [],
      zones: [],
      matrix: {},
      streamTotals: {},
      zoneTotals: {},
      grandTotal: 0,
      subCounties: [],
      wards: [],
      activeZones: 0,
      selectedStream: {
        incomeTypePrefix: '',
        streamName: ''
      },
      streamTransactions: {
        transactions: [],
        summary: null,
        breakdown: [],
        breakdownType: 'subcounty'
      },
      streamTransactionLoading: false,
      streamFilters: {
        subCounty: '',
        ward: '',
        zone: ''
      },
      streamTransactionCurrentPage: 1,
      streamTransactionPageSize: 20,
      showBreakdown: false
    }
  },

  computed: {
    displayDateRange() {
      if (this.dateRangeType === 'today') {
        return moment().format('MMMM D, YYYY');
      } else if (this.dateRangeType === 'week') {
        return `${moment().startOf('week').format('MMM D')} - ${moment().endOf('week').format('MMM D, YYYY')}`;
      } else if (this.dateRangeType === 'month') {
        return moment(this.dateFrom).format('MMMM YYYY');
      } else if (this.dateRangeType === 'year') {
        return moment(this.dateFrom).format('YYYY');
      } else {
        return `${moment(this.dateFrom).format('MMM D')} - ${moment(this.dateTo).format('MMM D, YYYY')}`;
      }
    },

    groupedZones() {
      const groups = {};
      this.zones.forEach(zone => {
        if (!groups[zone.subCountyName]) {
          groups[zone.subCountyName] = {
            subCounty: zone.subCountyName,
            wardGroups: {}
          };
        }
        if (!groups[zone.subCountyName].wardGroups[zone.wardName]) {
          groups[zone.subCountyName].wardGroups[zone.wardName] = {
            ward: zone.wardName,
            zones: []
          };
        }
        groups[zone.subCountyName].wardGroups[zone.wardName].zones.push(zone);
      });

      const result = Object.values(groups).map(group => ({
        subCounty: group.subCounty,
        wardGroups: Object.values(group.wardGroups).sort((a, b) => a.ward.localeCompare(b.ward))
      }));

      return result.sort((a, b) => a.subCounty.localeCompare(b.subCounty));
    },

    filteredWards() {
      if (!this.selectedSubCounty) {
        return this.wards;
      }
      return this.wards.filter(w => w.subCountyName === this.selectedSubCounty);
    },

    topZone() {
      let topName = '';
      let topAmount = 0;
      Object.entries(this.zoneTotals).forEach(([zone, amount]) => {
        if (amount > topAmount) {
          topAmount = amount;
          topName = zone;
        }
      });
      return { name: topName || 'N/A', amount: topAmount };
    },

    filteredStreamTransactions() {
      if (!this.streamTransactions.transactions) return [];
      let filtered = [...this.streamTransactions.transactions];
      if (this.streamFilters.subCounty) {
        filtered = filtered.filter(t => t.subCountyName === this.streamFilters.subCounty);
      }
      if (this.streamFilters.ward) {
        filtered = filtered.filter(t => t.wardName === this.streamFilters.ward);
      }
      if (this.streamFilters.zone) {
        filtered = filtered.filter(t => t.zone === this.streamFilters.zone);
      }
      return filtered;
    },

    paginatedStreamTransactions() {
      const start = (this.streamTransactionCurrentPage - 1) * this.streamTransactionPageSize;
      const end = start + this.streamTransactionPageSize;
      return this.filteredStreamTransactions.slice(start, end);
    },

    streamTransactionTotalPages() {
      return Math.ceil(this.filteredStreamTransactions.length / this.streamTransactionPageSize);
    },

    streamTransactionPageNumbers() {
      const pages = [];
      const total = this.streamTransactionTotalPages;
      const current = this.streamTransactionCurrentPage;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + 4);
      if (end - start < 4) {
        start = Math.max(1, end - 4);
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    uniqueSubCounties() {
      if (!this.streamTransactions.transactions) return [];
      return [...new Set(this.streamTransactions.transactions.map(t => t.subCountyName).filter(Boolean))].sort();
    },

    uniqueWards() {
      if (!this.streamTransactions.transactions) return [];
      let filtered = this.streamTransactions.transactions;
      if (this.streamFilters.subCounty) {
        filtered = filtered.filter(t => t.subCountyName === this.streamFilters.subCounty);
      }
      return [...new Set(filtered.map(t => t.wardName).filter(Boolean))].sort();
    },

    uniqueZones() {
      if (!this.streamTransactions.transactions) return [];
      let filtered = this.streamTransactions.transactions;
      if (this.streamFilters.subCounty) {
        filtered = filtered.filter(t => t.subCountyName === this.streamFilters.subCounty);
      }
      if (this.streamFilters.ward) {
        filtered = filtered.filter(t => t.wardName === this.streamFilters.ward);
      }
      return [...new Set(filtered.map(t => t.zone).filter(Boolean))].sort();
    }
  },

  mounted() {
    this.setDateRange('month');
    this.getRevenueData();
    this.menuAccess();
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Revenue Stream by Zone");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).then(() => {}).catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    setDateRange(type) {
      this.dateRangeType = type;
      const now = moment();
      switch(type) {
        case 'today':
          this.dateFrom = now.format('YYYY-MM-DD');
          this.dateTo = now.format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'week':
          this.dateFrom = now.startOf('week').format('YYYY-MM-DD');
          this.dateTo = now.endOf('week').format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'month':
          this.dateFrom = now.startOf('month').format('YYYY-MM-DD');
          this.dateTo = now.clone().endOf('month').format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'year':
          this.dateFrom = now.startOf('year').format('YYYY-MM-DD');
          this.dateTo = now.endOf('year').format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'custom':
          if (!this.dateFrom || !this.dateTo) {
            this.dateFrom = now.startOf('month').format('YYYY-MM-DD');
            this.dateTo = now.clone().endOf('month').format('YYYY-MM-DD');
          }
          break;
      }
    },

    toggleView() {
      this.viewType = this.viewType === 'amount' ? 'percentage' : 'amount';
    },

    refreshData() {
      this.getRevenueData();
    },

    onSubCountyChange() {
      this.selectedWard = '';
      this.getRevenueData();
    },

    clearFilters() {
      this.selectedSubCounty = '';
      this.selectedWard = '';
      this.getRevenueData();
    },

    getTotalZoneCount(group) {
      return group.wardGroups.reduce((total, ward) => total + ward.zones.length, 0);
    },

    getAmount(stream, zone) {
      return this.matrix[stream] && this.matrix[stream][zone] ? this.matrix[stream][zone] : 0;
    },

    getPercentage(stream, zone) {
      const amount = this.getAmount(stream, zone);
      const total = this.streamTotals[stream] || 0;
      return total > 0 ? ((amount / total) * 100).toFixed(1) : '0.0';
    },

    getRevenueData() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getRevenueStreamByZoneReport");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCounty", this.selectedSubCounty);
      data.append("ward", this.selectedWard);

      execute2(data, biller).then((res) => {
        this.loading = false;
        if (res.data.success) {
          const reportData = res.data.data.data;
          this.revenueStreams = reportData.revenueStreams || [];
          this.zones = reportData.zones || [];
          this.matrix = reportData.matrix || {};
          this.streamTotals = reportData.streamTotals || {};
          this.zoneTotals = reportData.zoneTotals || {};
          this.grandTotal = reportData.grandTotal || 0;
          this.subCounties = reportData.subCounties || [];
          this.wards = reportData.wards || [];
          this.activeZones = reportData.activeZones || 0;
        } else {
          alert(res.data.message);
        }
      }).catch((e) => {
        this.loading = false;
        console.error('Error loading revenue data:', e);
        alert('Failed to load revenue data. Please try again.');
      });
    },

    openStreamTransactionsModal(stream) {
      this.selectedStream = {
        incomeTypePrefix: stream.incomeTypePrefix,
        streamName: stream.revenueStream
      };
      this.streamFilters = { subCounty: '', ward: '', zone: '' };
      this.streamTransactionCurrentPage = 1;
      this.getStreamTransactions();
      const modalElement = document.getElementById('revenueStreamModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    getStreamTransactions() {
      this.streamTransactionLoading = true;
      const data = new FormData();
      data.append("function", "getRevenueStreamTransactions");
      data.append("incomeTypePrefix", this.selectedStream.incomeTypePrefix);
      data.append("streamName", this.selectedStream.streamName);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCounty", this.selectedSubCounty);
      data.append("ward", this.selectedWard);
      data.append("zone", this.streamFilters.zone);

      execute2(data, biller).then((res) => {
        this.streamTransactionLoading = false;
        if (res.data.success) {
          this.streamTransactions = res.data.data.data;
        } else {
          alert(res.data.message);
        }
      }).catch((e) => {
        this.streamTransactionLoading = false;
        console.error('Error loading stream transactions:', e);
        alert('Failed to load transactions. Please try again.');
      });
    },

    toggleBreakdownView() {
      this.showBreakdown = !this.showBreakdown;
    },

    filterStreamTransactions() {
      this.streamTransactionCurrentPage = 1;
    },

    clearStreamFilters() {
      this.streamFilters = { subCounty: '', ward: '', zone: '' };
      this.streamTransactionCurrentPage = 1;
    },

    getBreakdownTitle() {
      const type = this.streamTransactions.breakdownType || 'subcounty';
      switch(type) {
        case 'zone': return 'Zone';
        case 'ward': return 'Ward';
        default: return 'Sub-County';
      }
    },

    getBreakdownKey(item) {
      const type = this.streamTransactions.breakdownType || 'subcounty';
      switch(type) {
        case 'zone': return item.zone || item.zoneName;
        case 'ward': return item.wardName;
        default: return item.subCountyName;
      }
    },

    getBreakdownName(item) {
      const type = this.streamTransactions.breakdownType || 'subcounty';
      switch(type) {
        case 'zone':
          return `${item.zone || item.zoneName} (${item.wardName}, ${item.subCountyName})`;
        case 'ward':
          return `${item.wardName} (${item.subCountyName})`;
        default:
          return item.subCountyName;
      }
    },

    exportStreamTransactions() {
      const transactions = this.filteredStreamTransactions;
      if (transactions.length === 0) {
        alert('No transactions to export.');
        return;
      }

      const headers = [
        'Transaction Code', 'Bill Number', 'Date', 'Agent ID', 'Phone Number',
        'Customer Name', 'Amount', 'Income Type Description', 'Fee Description',
        'Department', 'Sub-County', 'Ward', 'Zone', 'Description'
      ];

      const rows = [headers.join(',')];

      transactions.forEach(t => {
        const row = [
          `"${t.transaction_code}"`,
          `"${t.receiptNumber || ''}"`,
          `"${this.formatDateForExport(t.date)}"`,
          `"${t.idNo || ''}"`,
          `"${t.phoneNumber || ''}"`,
          `"${t.names || ''}"`,
          t.amount,
          `"${t.incomeTypeDescription || ''}"`,
          `"${t.feeDescription || ''}"`,
          `"${t.department || ''}"`,
          `"${t.subCountyName || ''}"`,
          `"${t.wardName || ''}"`,
          `"${t.zone || ''}"`,
          `"${t.description || ''}"`
        ];
        rows.push(row.join(','));
      });

      rows.push('');
      rows.push('Summary');
      rows.push(`Stream:,"${this.selectedStream.streamName}"`);
      rows.push(`Prefix:,"${this.selectedStream.incomeTypePrefix}"`);
      rows.push(`Date Range:,"${this.displayDateRange}"`);
      rows.push(`Sub-County Filter:,"${this.selectedSubCounty || 'All'}"`);
      rows.push(`Ward Filter:,"${this.selectedWard || 'All'}"`);
      rows.push(`Total Transactions:,${this.streamTransactions.summary.totalTransactions}`);
      rows.push(`Total Amount:,${this.streamTransactions.summary.totalAmount}`);
      rows.push(`Unique Agents:,${this.streamTransactions.summary.totalAgents}`);

      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${this.selectedStream.incomeTypePrefix}_zone_transactions_${this.dateFrom}_to_${this.dateTo}.csv`;
      link.click();
    },

    formatDate(dateString) {
      return moment(dateString).format('MMM D, YYYY h:mm A');
    },

    formatDateForExport(dateString) {
      return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
    },

    downloadToExcel() {
      const workbook = XLSX.utils.book_new();

      const rows = [];

      // Row 1 - Sub-counties
      const header1 = ['#', 'REVENUE STREAM'];
      this.groupedZones.forEach(group => {
        const zoneCount = group.wardGroups.reduce((sum, ward) => sum + ward.zones.length, 0);
        for (let i = 0; i < zoneCount; i++) {
          header1.push(group.subCounty);
        }
      });
      header1.push('TOTAL');
      rows.push(header1);

      // Row 2 - Wards
      const header2 = ['', ''];
      this.groupedZones.forEach(group => {
        group.wardGroups.forEach(wardGroup => {
          for (let i = 0; i < wardGroup.zones.length; i++) {
            header2.push(wardGroup.ward);
          }
        });
      });
      header2.push('');
      rows.push(header2);

      // Row 3 - Zones
      const header3 = ['', ''];
      this.groupedZones.forEach(group => {
        group.wardGroups.forEach(wardGroup => {
          wardGroup.zones.forEach(zone => {
            header3.push(zone.zoneName);
          });
        });
      });
      header3.push('');
      rows.push(header3);

      // Revenue stream data rows
      this.revenueStreams.forEach((stream, index) => {
        const row = [index + 1, stream.revenueStream];
        this.groupedZones.forEach(group => {
          group.wardGroups.forEach(wardGroup => {
            wardGroup.zones.forEach(zone => {
              const amount = this.getAmount(stream.revenueStream, zone.zoneName);
              row.push(this.formatPrice(amount));
            });
          });
        });
        row.push(this.formatPrice(this.streamTotals[stream.revenueStream] || 0));
        rows.push(row);
      });

      // Grand total row
      const totalRow = ['', 'ZONE TOTALS'];
      this.groupedZones.forEach(group => {
        group.wardGroups.forEach(wardGroup => {
          wardGroup.zones.forEach(zone => {
            totalRow.push(this.formatPrice(this.zoneTotals[zone.zoneName] || 0));
          });
        });
      });
      totalRow.push(this.formatPrice(this.grandTotal));
      rows.push(totalRow);

      // Empty row
      rows.push([]);

      // Summary
      rows.push(['Zone Performance Summary']);
      rows.push(['Highest Revenue Zone:', this.topZone.name, this.formatPrice(this.topZone.amount)]);
      rows.push(['Active Zones:', `${this.activeZones} of ${this.zones.length}`]);
      rows.push(['Inactive Zones:', this.zones.length - this.activeZones]);
      rows.push(['Zone Coverage:', `${this.zones.length > 0 ? ((this.activeZones / this.zones.length) * 100).toFixed(1) : 0}%`]);
      rows.push([]);
      rows.push(['Date Range:', this.displayDateRange]);
      rows.push(['Sub-County Filter:', this.selectedSubCounty || 'All']);
      rows.push(['Ward Filter:', this.selectedWard || 'All']);
      rows.push(['Total Revenue:', this.formatPrice(this.grandTotal)]);
      rows.push(['Total Zones:', this.zones.length]);
      rows.push(['Active Zones:', this.activeZones]);

      // Convert to worksheet and export
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Revenue Report');

      const filters = this.selectedWard ? `_${this.selectedWard}_ward` :
          (this.selectedSubCounty ? `_${this.selectedSubCounty}_subcounty` : '');
      const filename = `revenue_by_zone${filters}_${this.dateFrom}_to_${this.dateTo}.xlsx`;

      XLSX.writeFile(workbook, filename);
    },


    downloadToCSV() {
      const rows = [];

      // Row 1 - Sub-counties
      const header1 = ['#', 'REVENUE STREAM'];
      this.groupedZones.forEach(group => {
        // Add the sub-county name for each zone under it
        const zoneCount = group.wardGroups.reduce((sum, ward) => sum + ward.zones.length, 0);
        for (let i = 0; i < zoneCount; i++) {
          header1.push(group.subCounty);
        }
      });
      header1.push('TOTAL');
      rows.push(header1.map(h => `"${h}"`).join(','));

      // Row 2 - Wards
      const header2 = ['', '']; // Empty cells for # and REVENUE STREAM columns
      this.groupedZones.forEach(group => {
        group.wardGroups.forEach(wardGroup => {
          // Add the ward name for each zone under it
          for (let i = 0; i < wardGroup.zones.length; i++) {
            header2.push(wardGroup.ward);
          }
        });
      });
      header2.push(''); // Empty cell for TOTAL column
      rows.push(header2.map(h => `"${h}"`).join(','));

      // Row 3 - Zones
      const header3 = ['', '']; // Empty cells for # and REVENUE STREAM columns
      this.groupedZones.forEach(group => {
        group.wardGroups.forEach(wardGroup => {
          wardGroup.zones.forEach(zone => {
            header3.push(zone.zoneName);
          });
        });
      });
      header3.push(''); // Empty cell for TOTAL column
      rows.push(header3.map(h => `"${h}"`).join(','));

      // Add revenue stream data rows
      this.revenueStreams.forEach((stream, index) => {
        const row = [index + 1, `"${stream.revenueStream}"`];

        // Add zone values in the correct order
        this.groupedZones.forEach(group => {
          group.wardGroups.forEach(wardGroup => {
            wardGroup.zones.forEach(zone => {
              const amount = this.getAmount(stream.revenueStream, zone.zoneName);
              row.push(amount);
            });
          });
        });

        // Add row total
        row.push(this.streamTotals[stream.revenueStream] || 0);
        rows.push(row.join(','));
      });

      // Add the grand total row
      const totalRow = ['', '"ZONE TOTALS"'];
      this.groupedZones.forEach(group => {
        group.wardGroups.forEach(wardGroup => {
          wardGroup.zones.forEach(zone => {
            totalRow.push(this.zoneTotals[zone.zoneName] || 0);
          });
        });
      });
      totalRow.push(this.grandTotal);
      rows.push(totalRow.join(','));

      // Add empty row
      rows.push('');

      // Add summary section
      rows.push('"Zone Performance Summary"');
      rows.push(`"Highest Revenue Zone:","${this.topZone.name}",${this.topZone.amount}`);
      rows.push(`"Active Zones:",${this.activeZones} of ${this.zones.length}`);
      rows.push(`"Inactive Zones:",${this.zones.length - this.activeZones}`);
      rows.push(`"Zone Coverage:",${this.zones.length > 0 ? ((this.activeZones / this.zones.length) * 100).toFixed(1) : 0}%`);
      rows.push('');
      rows.push(`"Date Range:","${this.displayDateRange}"`);
      rows.push(`"Sub-County Filter:","${this.selectedSubCounty || 'All'}"`);
      rows.push(`"Ward Filter:","${this.selectedWard || 'All'}"`);
      rows.push(`"Total Revenue:",${this.grandTotal}`);
      rows.push(`"Total Zones:",${this.zones.length}`);
      rows.push(`"Active Zones:",${this.activeZones}`);

      // Create CSV content
      const csvContent = rows.join('\n');

      // Create and download the file with BOM for better Excel compatibility
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      // Create filename with filters
      const filters = this.selectedWard ? `_${this.selectedWard}_ward` :
          (this.selectedSubCounty ? `_${this.selectedSubCounty}_subcounty` : '');
      link.download = `revenue_by_zone${filters}_${this.dateFrom}_to_${this.dateTo}.csv`;
      link.click();
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.table-responsive {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.table thead th {
  white-space: nowrap;
  font-size: 0.875rem;
}

.table td {
  white-space: nowrap;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.7rem;
}

.bg-secondary {
  background-color: #6c757d !important;
}

.text-success {
  font-weight: 600;
}
</style>